<div class="content-without-stepper-and-title">
    <div class="row">
      <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
        <div class="image">
          <img src="assets/images/{{ copies.image }}" alt="{{copies.image}}" />
        </div>
        <div class="subtitle mt-4" [innerHTML]="copies.subtitle"></div>
      </div>
    </div>
    <app-controls [nextLabel]="copies.button" (next)="next()"></app-controls>
  </div>
  